var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { action, makeObservable, observable } from 'mobx';
import { addressBookApi } from './address-book-api';
import { caseTypeApi } from '../case-types/case-type-api';
import { buildAddressString } from './models';
import { hasId } from '../common/ids';
var AddressBookStore = /** @class */ (function () {
    function AddressBookStore(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: rootStore
        });
        Object.defineProperty(this, "isBusy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        // properties
        Object.defineProperty(this, "addresses", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "caseTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        makeObservable(this);
        window.$AddressBookStore = this;
    }
    Object.defineProperty(AddressBookStore.prototype, "setBusy", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.isBusy = true;
        }
    });
    Object.defineProperty(AddressBookStore.prototype, "setNotBusy", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.isBusy = false;
        }
    });
    Object.defineProperty(AddressBookStore.prototype, "getAddresses", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var addresses, caseTypes;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setBusy();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 4, 5]);
                            return [4 /*yield*/, addressBookApi.getAddresses()];
                        case 2:
                            addresses = _a.sent();
                            this.setAddresses(addresses);
                            return [4 /*yield*/, caseTypeApi.getAllCaseTypes()];
                        case 3:
                            caseTypes = _a.sent();
                            this.setCaseTypes(caseTypes);
                            return [3 /*break*/, 5];
                        case 4:
                            this.setNotBusy();
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
    });
    ;
    Object.defineProperty(AddressBookStore.prototype, "createOrUpdateItem", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (addressItem) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setBusy();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 7, 8]);
                            if (!hasId(addressItem.id)) return [3 /*break*/, 3];
                            return [4 /*yield*/, addressBookApi.updateAddressItem(addressItem)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 5];
                        case 3: return [4 /*yield*/, addressBookApi.createAddressItem(addressItem)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5: return [4 /*yield*/, this.getAddresses()];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 8];
                        case 7:
                            this.setNotBusy();
                            return [7 /*endfinally*/];
                        case 8: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(AddressBookStore.prototype, "deleteItem", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setBusy();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 4, 5]);
                            return [4 /*yield*/, addressBookApi.deleteItem(id)];
                        case 2:
                            if (!(_a.sent()))
                                alert('Error');
                            return [4 /*yield*/, this.getAddresses()];
                        case 3:
                            _a.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            this.setNotBusy();
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(AddressBookStore.prototype, "setAddresses", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (addresses) {
            addresses.sort(function (address1, address2) {
                var a = buildAddressString(address1);
                var b = buildAddressString(address2);
                if (a > b)
                    return 11;
                if (a < b)
                    return -1;
                return 0;
            });
            this.addresses = addresses;
            var _loop_1 = function (caseType) {
                caseType.addresses = addresses.filter(function (a) { var _a; return ((_a = a.caseTypeIds) === null || _a === void 0 ? void 0 : _a.findIndex(function (t) { return t === caseType.id; })) !== -1; });
            };
            for (var _i = 0, _a = this.rootStore.caseTypesStore.caseTypes; _i < _a.length; _i++) {
                var caseType = _a[_i];
                _loop_1(caseType);
            }
        }
    });
    Object.defineProperty(AddressBookStore.prototype, "setCaseTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypes) {
            this.caseTypes = caseTypes;
        }
    });
    __decorate([
        observable
    ], AddressBookStore.prototype, "isBusy", void 0);
    __decorate([
        observable
    ], AddressBookStore.prototype, "addresses", void 0);
    __decorate([
        observable
    ], AddressBookStore.prototype, "caseTypes", void 0);
    __decorate([
        action
    ], AddressBookStore.prototype, "setBusy", null);
    __decorate([
        action
    ], AddressBookStore.prototype, "setNotBusy", null);
    __decorate([
        action
    ], AddressBookStore.prototype, "getAddresses", null);
    __decorate([
        action
    ], AddressBookStore.prototype, "createOrUpdateItem", null);
    __decorate([
        action
    ], AddressBookStore.prototype, "deleteItem", null);
    __decorate([
        action
    ], AddressBookStore.prototype, "setAddresses", null);
    __decorate([
        action
    ], AddressBookStore.prototype, "setCaseTypes", null);
    return AddressBookStore;
}());
export default AddressBookStore;
